import { render, staticRenderFns } from "./SkeletonList.vue?vue&type=template&id=0d99ab7a&scoped=true&"
import script from "./SkeletonList.vue?vue&type=script&lang=js&"
export * from "./SkeletonList.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonList.vue?vue&type=style&index=0&id=0d99ab7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d99ab7a",
  null
  
)

export default component.exports